<button #trigger type="button" class="feedback-trigger" (click)="open(trigger)">
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M4 5h16v11H8l-4 4V5Z" />
  </svg>
  Roast me anonymously
</button>
<p class="feedback-hint">Spotted a bug, a typo, or a design crime? Tell me. It’s anonymous, so be brutal. My ego has error handling.</p>

<div #modal class="fb-modal" [class.is-open]="isOpen()" (keydown)="onKeydown($event)">
  <div class="fb-backdrop" (click)="close()"></div>
  <div #panel class="fb-panel" role="dialog" aria-modal="true" aria-labelledby="fb-title" tabindex="-1">
    <header class="fb-head">
      <div>
        <span class="fb-tag">Anonymous · no name, no email</span>
        <h3 id="fb-title">Go on, be honest</h3>
      </div>
      <button type="button" class="fb-close" (click)="close()" aria-label="Close feedback" title="Close">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" /></svg>
      </button>
    </header>

    @if (status() === 'sent') {
      <div class="fb-done" role="status">
        <p class="fb-done-title">Received. Filed under “character building”.</p>
        <p class="fb-done-sub">Thanks, genuinely. I read every single one, usually with chai.</p>
        <div class="fb-actions">
          <button type="button" class="fb-btn ghost" (click)="writeAnother()">Roast me again</button>
          <button type="button" class="fb-btn primary" (click)="close()">Done</button>
        </div>
      </div>
    } @else {
      <form class="fb-form" (submit)="submit($event)" novalidate>
        <div class="fb-moods" role="group" aria-labelledby="fb-mood-label">
          <span id="fb-mood-label" class="fb-label">Overall vibe? <span class="fb-optional">(optional)</span></span>
          <div class="fb-mood-row">
            @for (m of moods; track m.value) {
              <button type="button" class="fb-mood" [class.is-active]="mood() === m.value" [attr.aria-pressed]="mood() === m.value" (click)="pickMood(m.value)">
                <span class="fb-mood-emoji" aria-hidden="true">{{ m.emoji }}</span>
                {{ m.label }}
              </button>
            }
          </div>
        </div>
        <label class="fb-label" for="fb-message">Feedback, praise, bug reports, or brutal honesty</label>
        <textarea
          #field
          id="fb-message"
          name="message"
          rows="6"
          [maxLength]="maxLength"
          [value]="message()"
          (input)="onInput($event)"
          placeholder="The dark mode is nice but your jokes need a code review…"
        ></textarea>
        <!-- Honeypot for bots; hidden from people and screen readers -->
        <input class="fb-hp" type="text" name="website" tabindex="-1" autocomplete="off" aria-hidden="true" />
        <div class="fb-meta">
          <span>{{ message().length }} / {{ maxLength }}</span>
          @if (status() === 'error') {
            <span class="fb-error" role="alert">That didn’t go through. Check your connection and try again.</span>
          }
        </div>
        <div class="fb-actions">
          <button type="button" class="fb-btn ghost" (click)="close()">Never mind</button>
          <button type="submit" class="fb-btn primary" [disabled]="!canSend()">
            {{ status() === 'sending' ? 'Sending…' : 'Send it' }}
          </button>
        </div>
      </form>
    }
  </div>
</div>
